
export function _setCustomerListArray(state, val) {
    state.customerList = val
}

export function _setCustomerWaitListArray(state, val) {
    state.customerWaitList = val
}
